import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/index'
//import Info from '@/components/main/info'
import Tickets from '@/components/cards/tickets'
import Member from '@/components/cards/member'
import Expense from '@/components/cards/expense'
import Recharge from '@/components/cards/recharge'
import ExpenseCalendar from '@/components/cards/expenseCalendar'
Vue.use(Router)

export default new Router({
  // mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index
    },
    // {
    //   path: '/info',
    //   name: 'info',
    //   component: Info
    // },
    {
      path: '/tickets',
      name: 'tickets',
      component: Tickets
    },
    {
      path: '/member',
      name: 'member',
      component: Member
    },
    {
      path: '/expense',
      name: 'expense',
      component: Expense
    },
    {
      path: '/recharge',
      name: 'recharge',
      component: Recharge
    },
    {
      path: '/expenseCalendar',
      name: 'expenseCalendar',
      component: ExpenseCalendar
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js